import { Component, Watch, Vue } from 'vue-property-decorator';
import { LoginModel } from '@/models';
import * as ACTIONS from '@/store/mutation-types';



@Component({})
export default class LoginForm extends Vue {
  public drawer: boolean = true;
  public username: null;
  public password: string = null;
  public portalid: string = null;
  public clientId: null;
  public secret: null;
  public appType: null;
  public loginFailed: boolean = false;
  public showAdvanced: boolean = false;
  public isError: boolean = false;
  public errorText: string = null;

  public get busy() {
    return this.$store.getters.isBusy;
  }

  public login() {
    this.$authService.login(this.username, this.password)
      .then((r) => {

        console.log("r.data", r.data);
        if (r.data.status === 200) {
          this.$router.push('/');

        }
        else {
          this.isError = true;
          this.errorText = 'You are not a gumshoe!';
        }
      })
      .catch(err => {
        this.isError = true;
        this.errorText = 'You are not a gumshoe!';
      });
  }
  
}
